// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__14ub2","inputWrap":"styles_inputWrap__GJZg3","input":"styles_input__2ZNdR"};